import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, useSearchParams } from 'react-router-dom';
import './common.css';
import { getPageTitle } from '../constants';

const ResetPassword: React.FC = () => {
  const { translations } = useOutletContext<{ translations: Record<string, string> }>();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState<"error" | "success">("error");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    document.title = getPageTitle(translations["password.reset.title"]);
  }, [translations]);

  const handleError = (error: any) => {
    setMessageType("error");
    const data = error.response?.data;
    if (data?.errorCode === "incorrectEmail") {
      setMessage(translations["userNotFoundByEmail"]);
    } else if (data?.errorCode === "EMPTY_INPUT_ERROR") {
      setMessage(translations["emptyInputError"]);
    } else {
      const errorMsg = typeof data === 'object' ? (data?.error || data?.message || JSON.stringify(data)) : data;
      setMessage(`${error.response?.status || "Error"}: ${errorMsg || error.message}`);
    }
  };

  const handleSendResetLink = async () => {
    if (!email) {
      setMessageType("error");
      setMessage(translations["emptyInputError"]);
      return;
    }

    try {
      const response = await axios.post(`/api/site/sendResetPasswordLinkEmail`, { email });
      setMessageType("success");
      setMessage(response.data.message);
      setSubmitted(true);
    } catch (error: any) {
      handleError(error);
    }
  };

  const handleSetNewPassword = async () => {
    if (!password) {
      setMessageType("error");
      setMessage(translations["emptyInputError"]);
      return;
    }

    try {
      const response = await axios.post(`/api/site/sendResetPasswordLinkEmail`, { password, hash });
      setMessageType("success");
      setMessage(response.data.message);
      setSubmitted(true);
    } catch (error: any) {
      handleError(error);
    }
  };

  const handleSubmit = hash ? handleSetNewPassword : handleSendResetLink;

  return (
    <div className="page-content" style={{ display: 'block' }}>
      <div className="search-panel" style={{ maxWidth: 450, margin: '0 auto' }}>
        <h3>{translations["password.reset.title"]}</h3>
        <form className="search-form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          {hash ? (
            <div className="form-group">
              <label htmlFor="password">{translations["password.reset.newPassword"]}</label>
              <input
                className="search-input"
                id="password"
                name="password"
                type="password"
                placeholder={translations["user.info.password"]}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="email">{translations["password.reset.heading"]}</label>
              <input
                className="search-input"
                id="email"
                name="email"
                type="email"
                placeholder={translations["user.info.email"]}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          )}

          {message && (
            <div style={{
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
              fontWeight: "bold",
              color: "#fff",
              backgroundColor: messageType === "success" ? "#22c55e" : "#FF1945"
            }}>
              {message}
            </div>
          )}

          <button type="submit" className="search-button" disabled={submitted}>
            {translations["password.reset.send"]}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
